import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { ProgressBar } from "primereact/progressbar";
import { usePortalAuthentication } from "../../services/authorizationService";

const passwordValidatorConstants = {
  digits: /\d+/,
  letters: /[a-zA-Z]+/,
  uppercase: /[A-Z]+/,
  lowercase: /[a-z]+/,
  symbols: /[`~\!@#\$%\^\&\*\(\)\-_\=\+\[\{\}\]\\\|;:'",<.>\/\?€£¥₹]+/,
  spaces: /[\s]+/,
  repeat: /(.+)\1{1,}/, //  /(.+).*(\1.*){1,}/  ,///(.+)\1{1,}/
  seq: /(ab|bc|cd|de|ef|fg|gh|hi|ij|jk|kl|lm|mn|no|op|pq|qr|rs|st|tu|uv|vw|wx|xy|yz|01|12|23|34|45|56|67|78|89)+/,
};

const BodyPassword = () => {
  const { userToken, userSession, SetSharedObject, sharedObject, userRole } =
    useUserStore((state) => ({
      userToken: state.userToken,
      userSession: state.userSession,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userRole: state.userRole,
    }));

  const { login } = usePortalAuthentication();
  const navigate = useNavigate();
  const [currentPasswordFlag, SetCurrentPasswordFlag] = useState(true);
  const [PasswordMatchFlag, SetPasswordMatchFlag] = useState(false);
  const [errFlag, setErrFlag] = useState(false);
  const [userName, setUserName] = useState(
    userSession.preferred_username ?? "",
  );
  const [isUsernameInvalid, setIsUsernameInvalid] = useState(false);
  const [errMsg, setErrMsg] = useState(
    "System encountered an error. Please try again or contact administrator.",
  );
  const [userCode, setUserCode] = useState();
  const [isResettingPassword, setIsResettingPassword] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false);
  const [resetFlag, setResetFlag] = useState(false);
  const [processing, SetProcesing] = useState(false);
  const [meter, SetMeter] = useState("");
  const [showCurrentPassword, SetShowCurrentPassword] = useState(false);
  const [showNewPassword, SetShowNewPassword] = useState(false);
  const [showConfirmPassword, SetShowConfirmPassword] = useState(false);
  const [submitFlag, SetSubmitFlag] = useState(false);
  const [answers, setAnswers] = useState({
    CurrentPassword: "",
    NewPassword: "",
    NewPasswordRepeat: "",
  });
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };

  useEffect(() => {
    setResetFlag(false);

    if (
      sharedObject.ResetPasswordObj?.UserId &&
      sharedObject.ResetPasswordObj?.Code
    ) {
      setIsResettingPassword(true);
      setUserCode(sharedObject.ResetPasswordObj?.Code);
    } else {
      setIsResettingPassword(false);
    }

    return () => {
      SetSharedObject("changePasswordFlag", false);
    };
  }, [sharedObject.ResetPasswordObj]);

  const submitChangePassword = async () => {
    SetSubmitFlag(true);
    SetPasswordMatchFlag(false);
    setResetFlag(false);
    setSuccessFlag(false);
    setErrFlag(false);

    if (isResettingPassword && !userName) {
      setIsUsernameInvalid(true);
      document.getElementById("Username").scrollIntoView();
      document.getElementById("Username").focus();
      return;
    } else if (answers.CurrentPassword === "" && !isResettingPassword) {
      document.getElementById("CurrentPassword").scrollIntoView();
      document.getElementById("CurrentPassword").focus();
      return;
    } else if (answers?.NewPassword === "") {
      document.getElementById("NewPassword").scrollIntoView();
      document.getElementById("NewPassword").focus();
      return;
    } else if (answers?.NewPasswordRepeat === "") {
      document.getElementById("NewPasswordRepeat").scrollIntoView();
      document.getElementById("NewPasswordRepeat").focus();
      return;
    }

    if (answers.NewPassword !== answers.NewPasswordRepeat) {
      SetPasswordMatchFlag(true);
      return;
    }

    let call = "";
    let mdl = {};
    if (!isResettingPassword) {
      if (sharedObject.ResetPasswordId) {
        call = "/admin/UserchangePassword";
      } else {
        call = "/admin/ChangePassword";
      }
      mdl = {
        OldPassword: answers.CurrentPassword,
        NewPassword: answers.NewPassword,
        ConfirmPassword: answers.NewPasswordRepeat,
      };
    } else {
      call = "/admin/PasswordReset";
      mdl = {
        Code: userCode,
        Password: answers.NewPassword,
        ConfirmPassword: answers.NewPasswordRepeat,
        userName: userName,
      };
    }
    SetProcesing(true);
    const res = await CallAPI(call, mdl, "post", userToken);
    SetSharedObject("ResponseCode", res.code);

    if (res && res.status === "SUCCESS") {
      if (!isResettingPassword) {
        if (sharedObject.changePasswordFlag) {
          setSuccessFlag(true);
        } else {
          if (res.data.page === "Register") {
            navigate("/pre-registration");
          } else if (res.data.page === "Dashboard") {
            if (userRole === "USER") {
              if (window !== "undefined") window.open("../webmail", "_self");
            } else {
              navigate("/dashboard");
            }
          } else if (res.data.page === "SSO") {
            navigate("/experian-sso");
          }
        }
      } else {
        setResetFlag(true);
      }

      SetSharedObject("ResetPasswordId", null);
      SetProcesing(false);
    } else if (res.status === "SERVERERROR") {
      if (
        res?.data &&
        Object.keys(res?.data).length > 0 &&
        res?.data[0]?.code === "PasswordMismatch"
      ) {
        setErrMsg("The current password you entered does not match.");
      } else if (res?.data?.code === "UsernameNotFound") {
        setErrMsg("Username does not match");
      } else if (
        res.data &&
        res.data.includes(
          "New password cannot be the same as the old password.",
        )
      ) {
        setErrMsg("New password cannot be the same as the old password.");
      }
      setErrFlag(true);
      SetProcesing(false);
    }
  };

  const ValidatePassword = async (val) => {
    SetCurrentPasswordFlag(true);
    let flag = true;
    if (val.length < 8 || val.length > 256) {
      flag = false;
      SetCurrentPasswordFlag(true);
      SetMeter(0);
    } else if (val.length >= 8 && val.length <= 256) {
      if (_process(passwordValidatorConstants.seq, val)) {
        SetCurrentPasswordFlag(true);
        SetMeter(0);
      } else {
        const numberRegex = /\d/;
        const specialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        let nr = numberRegex.test(val);
        let specialChar = specialCharRegex.test(val);
        flag = nr && specialChar;
        if (flag) {
          SetMeter(2);
        } else {
          SetMeter(1);
        }
        SetCurrentPasswordFlag(false);
      }
    }
    await setAnswer("NewPassword", val);
  };

  const _process = (regexp, password) => {
    let pw = password.toLowerCase();
    let uname = userName ? userName.toLowerCase() : "";
    let fname = userSession.given_name
      ? userSession.given_name.toLowerCase()
      : "";
    let lname = userSession.family_name
      ? userSession.family_name.toLowerCase()
      : "";
    let check = false;
    if (new RegExp(regexp).test(password)) {
      check = true;
    } else if (
      (uname && pw.includes(uname)) ||
      (!isResettingPassword && (pw.includes(fname) || pw.includes(lname)))
    ) {
      check = true;
    }
    return check;
  };

  const strengthLabel =
    meter === 0
      ? "Weak"
      : meter === 1
        ? "Good"
        : meter === 2
          ? "Strong"
          : "None";
  const strengthValue =
    meter === 0 ? 25 : meter === 1 ? 50 : meter === 2 ? 100 : 0;

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <>
      {resetFlag ? (
        <section
          className="layout-container"
          aria-label="Password reset confirmation"
        >
          <div className="container ctr">
            <div className="bi-success-check">
              <i className="bi bi-check2-circle" aria-hidden="true"></i>
            </div>
            <p
              className="lg-msg"
              role="alert"
              aria-live="polite"
              aria-atomic="true"
            >
              Password for {userName} has been changed successfully.
            </p>
            <button
              onClick={(e) => login()}
              className="btn btn-primary"
              type="button"
            >
              Sign In
            </button>
          </div>
        </section>
      ) : successFlag ? (
        <section
          className="layout-container"
          aria-label="Password change confirmation"
        >
          <div className="container ctr">
            <div className="bi-success-check" aria-hidden="true">
              <i className="bi bi-check2-circle"></i>
            </div>
            <p
              className="lg-msg"
              role="alert"
              aria-live="polite"
              aria-atomic="true"
            >
              Password for {userSession.given_name} {userSession.family_name}{" "}
              has been changed successfully.
            </p>
            <p className="descript-container">
              Your new password will take effect after you log out.
            </p>
          </div>
        </section>
      ) : (
        <div className="BodyPassword">
          <div className="left-panel">
            <form
              className="ch-pswd"
              aria-label="Change password form"
              noValidate
            >
              <div className="field-wrapper">
                <p className="descript-container">
                  To conform with our Strong Password Policy, you can use
                  passphrase with spaces or meet the required criteria to the
                  right.
                </p>
              </div>
              <div className="field-wrapper">
                <label htmlFor="Username">Username</label>
                <input
                  type="text"
                  value={
                    isResettingPassword ? userName : userName?.split("|")[0]
                  }
                  className="form-control"
                  id="Username"
                  autoComplete="username"
                  disabled={isResettingPassword ? false : true}
                  aria-required={isResettingPassword}
                  aria-invalid={
                    isUsernameInvalid && submitFlag ? "true" : "false"
                  }
                  aria-describedby={
                    isUsernameInvalid && submitFlag
                      ? "usernameError"
                      : undefined
                  }
                  aria-disabled={isResettingPassword ? false : true}
                  onChange={(el) => {
                    setUserName(el.target.value);
                    setIsUsernameInvalid(false);
                  }}
                />
                {isUsernameInvalid && submitFlag ? (
                  <div
                    className="alert alert-danger"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                  >
                    Username is required.
                  </div>
                ) : null}
              </div>
              {/* Current Password */}
              {/*Hide current password when resetting password.*/}
              {!isResettingPassword ? (
                <div className="field-wrapper">
                  <label htmlFor="CurrentPassword">Current Password</label>
                  <div className="input-group mb-3">
                    <input
                      type={showCurrentPassword ? "text" : "password"}
                      className="form-control password-input"
                      id="CurrentPassword"
                      autoComplete="current-password"
                      aria-required="true"
                      aria-describedby={
                        currentPasswordFlag && submitFlag
                          ? "currentPasswordError"
                          : undefined
                      }
                      value={answers.CurrentPassword}
                      onChange={(el) =>
                        setAnswer("CurrentPassword", el.target.value)
                      }
                    />
                    <div className="input-group-append">
                      <button
                        className="input-group-text btn btn-secondary"
                        id="show-current-password-btn"
                        type="button"
                        aria-label={
                          showCurrentPassword
                            ? "Hide current password"
                            : "Show current password"
                        }
                        aria-pressed={showCurrentPassword}
                        onClick={(e) =>
                          SetShowCurrentPassword(!showCurrentPassword)
                        }
                      >
                        <i
                          className={`bi ${
                            showCurrentPassword
                              ? "bi-eye-slash-fill"
                              : "bi-eye-fill"
                          }`}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                  </div>
                  {currentPasswordFlag && submitFlag ? (
                    <div
                      className="alert alert-danger"
                      role="alert"
                      id="currentPasswordError"
                      aria-live="assertive"
                      aria-atomic="true"
                    >
                      Current password does not match.
                    </div>
                  ) : null}
                </div>
              ) : null}
              {/* New Password */}
              <div className="field-wrapper">
                <label htmlFor="NewPassword">New Password</label>
                <div className="input-group mb-3">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className="form-control password-input"
                    autoComplete="new-password"
                    size="35"
                    id="NewPassword"
                    aria-required="true"
                    aria-describedby="passwordStrengthStatus newPasswordHint"
                    value={answers.NewPassword}
                    onChange={(el) => ValidatePassword(el.target.value)}
                  />
                  <div className="input-group-append">
                    <button
                      className="input-group-text btn btn-secondary"
                      id="show-new-password-btn"
                      type="button"
                      aria-label={
                        showNewPassword
                          ? "Hide new password"
                          : "Show new password"
                      }
                      aria-pressed={showNewPassword}
                      onClick={(e) => SetShowNewPassword(!showNewPassword)}
                    >
                      <i
                        className={`bi ${
                          showNewPassword ? "bi-eye-slash-fill" : "bi-eye-fill"
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
                </div>
                <span id="newPasswordHint" className="sr-only">
                  Minimum 8 characters. Must include a number and a special
                  character. Must not contain sequential or repeated characters,
                  or your username.
                </span>
              </div>
              {/* Password Strength */}
              <div className="field-wrapper">
                <label htmlFor="password-strength-meter">
                  Password Strength
                </label>
                <div className="card">
                  <div
                    role="progressbar"
                    aria-valuenow={strengthValue}
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-label={`Password strength: ${strengthLabel || "unknown"}`}
                    id="password-strength-meter"
                  >
                    <ProgressBar value={strengthValue} />
                  </div>
                </div>
                <p
                  id="passwordStrengthStatus"
                  aria-live="polite"
                  aria-atomic="true"
                  className="sr-only"
                >
                  {meter !== "" ? `Password strength: ${strengthLabel}` : ""}
                </p>

                {meter === 0 ? (
                  <div role="note" className="pswd-strength-weak">
                    <stong className="rd-clr">Weak</stong>
                    <ul>
                      <li>
                        Add another word or two. Uncommon words are better.
                      </li>
                      <li>Password length cannot be less than 8 characters.</li>
                      <li>Password is very weak and can be hacked easily.</li>
                      <li>Password must not contain repeated characters.</li>
                      <li>Password must not contain sequential characters.</li>
                    </ul>
                  </div>
                ) : meter === 1 ? (
                  <div role="note" className="pswd-strength-good">
                    <strong className="or-clr">Good</strong>
                    <ul>
                      <li>Password is good but still can be hacked.</li>
                      <li>
                        Password is acceptable but may need to be changed more
                        frequently.
                      </li>
                    </ul>
                  </div>
                ) : meter === 2 ? (
                  <div role="note">
                    <label className="g-clr">Strong</label>
                  </div>
                ) : null}
              </div>
              {/* Confirm Password */}
              <div className="field-wrapper">
                <label htmlFor="NewPasswordRepeat">Confirm Password</label>
                <div className="input-group mb-3">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control password-input"
                    autoComplete="new-password"
                    aria-required="true"
                    aria-describedby={
                      PasswordMatchFlag && submitFlag
                        ? "confirmPasswordError"
                        : undefined
                    }
                    id="NewPasswordRepeat"
                    value={answers.NewPasswordRepeat}
                    onChange={(el) =>
                      setAnswer("NewPasswordRepeat", el.target.value)
                    }
                  />
                  <div className="input-group-append">
                    <button
                      className="input-group-text btn btn-secondary"
                      id="show-confirm-password-btn"
                      type="button"
                      aria-label={
                        showConfirmPassword
                          ? "Hide confirm password"
                          : "Show confirm password"
                      }
                      aria-pressed={showConfirmPassword}
                      onClick={(e) =>
                        SetShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      <i
                        className={`bi ${
                          showConfirmPassword
                            ? "bi-eye-slash-fill"
                            : "bi-eye-fill"
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
                </div>
                {PasswordMatchFlag &&
                submitFlag &&
                answers.NewPasswordRepeat !== "" ? (
                  <div
                    className="alert alert-danger"
                    role="alert"
                    id="confirmPasswordError"
                    aria-live="assertive"
                    aria-atomic="true"
                  >
                    Confirmation password does not match
                  </div>
                ) : null}
              </div>
              {errFlag ? (
                <div
                  className="alert alert-danger"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  {errMsg}
                </div>
              ) : null}
              {/*After you update, should be the Experian page then back to the login*/}
              <div className="button-container">
                <button
                  onClick={(e) => submitChangePassword()}
                  type="button"
                  className="btn btn-success"
                  aria-busy={processing}
                  disabled={processing}
                >
                  {processing ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>

          <div className="right-panel">
            <div className="icon-container" aria-hidden="true">
              <i className="bi bi-shield-check"></i>
            </div>
            <h6 className="field-wrapper title-divider sp-pad9 sp-mx8">
              Password Criteria
            </h6>
            <ul>
              <li>
                Must be at least 8 characters in length and can be up to 256
                characters in length.
              </li>
              <li>
                Must not have repetitive or sequential characters (e.g., aa,
                abc123, 1111, 2323, 2000, xyz, abab, or 123), dictionary words,
                old passwords.
              </li>
              <li>
                Must not use common passwords like name, birthdays, usernames,
                etc.
              </li>
            </ul>
          </div>
        </div>
      )}
      {processing && (
        <div
          className="loader-container"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          aria-labelledby="body-password-loader"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="body-password-loader">
            {loadingText}
          </div>
        </div>
      )}
    </>
  );
};

export default BodyPassword;
